import React from 'react';
import NoImageIcon from '~/assets/icons/no_image.svg';

interface NoResultsProps {
  type: string;
  files: unknown[];
}

const NoResults: React.FC<NoResultsProps> = ({ type, files }) => {
  if (files.length === 0) {
    return (
      <div className="no_results">
        <NoImageIcon />
        <p>
          Recent{' '}
          {type === 'document'
            ? 'documents'
            : type === 'image'
              ? 'images'
              : 'videos'}{' '}
          will appear here
        </p>
      </div>
    );
  }
  return null;
};

export default NoResults;
